<ng-container *transloco="let t; read: 'user'">
  @if (enrollForm) {
    <div>
      <div class="flex justify-between border-b">
        <h1 class="text-[25px] font-bold">{{ t('searchDroppedChildren.enroll.title') }}</h1>
        <i mat-button mat-dialog-close class="text-drdpblue-300 cursor-pointer uil uil-times-circle"></i>
      </div>
      <div mat-dialog-content>
        <div class="grid grid-cols-2 gap-4 gap-x-10 mt-5">
          <!-- Server-supplied child data: localized by the API, not by Transloco. -->
          <div class="mb-5">
            <h3 class="font-bold text-[18px] mb-2">{{ t('searchDroppedChildren.fields.firstName') }}</h3>
            <p>{{ child.data.firstName }}</p>
          </div>
          <div class="mb-5">
            <h3 class="font-bold text-[18px] mb-2">{{ t('searchDroppedChildren.fields.lastName') }}</h3>
            <p>{{ child.data.lastName }}</p>
          </div>
          <div class="mb-5">
            <h3 class="font-bold text-[18px] mb-2">{{ t('searchDroppedChildren.fields.dateOfBirth') }}</h3>
            <p>{{ child.data.dob | localizedDate: 'MM/dd/yyyy' }}</p>
          </div>
          <div class="mb-5">
            <h3 class="font-bold text-[18px] mb-2">{{ t('searchDroppedChildren.fields.drdpId') }}</h3>
            <p>{{ child.data.drdpId }}</p>
          </div>
          <drdp-classroom-rating-period-params (formValues)="handleDropdownSelection($event)" class="contents">
          </drdp-classroom-rating-period-params>
        </div>
      </div>
      <div class="flex flex-row justify-end">
        <drdp-btn mat-button mat-dialog-close [color]="'cancel'">{{ t('searchDroppedChildren.actions.cancel') }}</drdp-btn>
        <drdp-btn [disabled]="!enrollForm.valid" class="ml-3" (click)="submit()">{{ t('searchDroppedChildren.actions.saveAndSubmit') }}</drdp-btn>
      </div>
    </div>
  }
</ng-container>
